import { gql } from "@apollo/client";

export const SlugQueries = {
  CHECK_SLUG_UNIQUENESS: gql`
    query CheckSlugUniqueness(
      $slug: String!
      $contentType: String!
      $schema_document_type: String
    ) {
      authoring_checkSlugUniqueness(
        slug: $slug
        contentType: $contentType
        schema_document_type: $schema_document_type
      ) {
        isUnique
        message
      }
    }
  `,
};
